<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Please Don't Eat the Daisies</title>
<link href="../style/9781504055741.css" rel="stylesheet" type="text/css"/>
<h2 class="chap-title"><span class="bold">Contents</span></h2>
<h2 class="tocN"><a href="#/xhtml/fm002"><em class="italic">Introduction</em></a></h2>
<h2 class="toc1"><a href="#/xhtml/chapter001"><em class="italic">Please don’t eat the daisies</em></a></h2>
<h2 class="toc"><span href="#/xhtml/chapter002" title="Link target outside of Sample"><em class="italic">How to be a collector’s item</em></span></h2>
<h2 class="toc"><span href="#/xhtml/chapter003" title="Link target outside of Sample"><em class="italic">Greenwich, anyone?</em></span></h2>
<h2 class="toc"><span href="#/xhtml/chapter004" title="Link target outside of Sample"><em class="italic">How to decorate in one easy breakdown</em></span></h2>
<h2 class="toc"><span href="#/xhtml/chapter005" title="Link target outside of Sample"><em class="italic">Dogs that have known me</em></span></h2>
<h2 class="toc"><span href="#/xhtml/chapter006" title="Link target outside of Sample"><em class="italic">The Kerr-Hilton</em></span></h2>
<h2 class="toc"><span href="#/xhtml/chapter007" title="Link target outside of Sample"><em class="italic">The care and feeding of producers</em></span></h2>
<h2 class="toc"><span href="#/xhtml/chapter008" title="Link target outside of Sample"><em class="italic">One half of two on the aisle</em></span></h2>
<h2 class="toc"><span href="#/xhtml/chapter009" title="Link target outside of Sample"><em class="italic">Don Brown’s body</em></span></h2>
<h2 class="toc"><span href="#/xhtml/chapter010" title="Link target outside of Sample"><em class="italic">Toujours tristesse</em></span></h2>
<h2 class="toc"><span href="#/xhtml/chapter011" title="Link target outside of Sample"><em class="italic">Snowflaketime</em></span></h2>
<h2 class="toc"><span href="#/xhtml/chapter012" title="Link target outside of Sample"><em class="italic">How to get the best of your children</em></span></h2>
<h2 class="toc"><span href="#/xhtml/chapter013" title="Link target outside of Sample"><em class="italic">Where did you put the aspirin?</em></span></h2>
<h2 class="toc"><span href="#/xhtml/chapter014" title="Link target outside of Sample"><em class="italic">Aunt Jean’s marshmallow fudge diet</em></span></h2>
<h2 class="toc"><span href="#/xhtml/chapter015" title="Link target outside of Sample"><em class="italic">Operation operation</em></span></h2>
<h2 class="tocN"><span href="#/xhtml/about" title="Link target outside of Sample"><em class="italic">About the Author</em></span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?cbc640d4